import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { ActivityClickOfferVariables } from "./types";

export const useActivityClickOffer = (
  options?: UseMutationOptions<
    void,
    PortalAxiosError,
    ActivityClickOfferVariables
  >
) => {
  const server = useServer();

  return useMutation<void, PortalAxiosError, ActivityClickOfferVariables>(
    ({ identifier }) => server.post(`offers/${identifier}/activity_feed_click`),
    options
  );
};

export default useActivityClickOffer;
